import React from 'react';

const Logo = ({ size = 'medium', showText = true }) => {
  const sizes = {
    small: {
      container: 'w-10 h-10',
      text: 'text-lg',
      letterSpacing: 'tracking-tight'
    },
    medium: {
      container: 'w-14 h-14',
      text: 'text-2xl',
      letterSpacing: 'tracking-tight'
    },
    large: {
      container: 'w-24 h-24',
      text: 'text-4xl',
      letterSpacing: 'tracking-tight'
    }
  };

  const sizeClasses = sizes[size] || sizes.medium;

  return (
    <div className="flex items-center gap-3">
      {/* Minimalist Logo Icon - Abstract "E" with arrow */}
      <div className={`${sizeClasses.container} relative group`}>
        {/* Outer glow ring */}
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-lg opacity-20 blur-md group-hover:opacity-40 transition-opacity"></div>
        
        {/* Main logo container */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 to-slate-800 rounded-lg border-2 border-cyan-500/50 flex items-center justify-center overflow-hidden">
          {/* Animated background gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 via-transparent to-blue-500/10 animate-pulse"></div>
          
          {/* Minimalist "E" shape with arrow */}
          <svg
            viewBox="0 0 100 100"
            className="w-full h-full p-2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* "E" letter strokes */}
            <path
              d="M 25 20 L 75 20 M 25 20 L 25 80 M 25 50 L 65 50 M 25 80 L 75 80"
              stroke="url(#gradient1)"
              strokeWidth="8"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="drop-shadow-[0_0_8px_rgba(6,182,212,0.5)]"
            />
            
            {/* Arrow pointing up-right */}
            <path
              d="M 55 35 L 75 15 L 75 35 M 75 15 L 55 15"
              stroke="url(#gradient2)"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="drop-shadow-[0_0_10px_rgba(250,204,21,0.6)]"
            />
            
            {/* Gradient definitions */}
            <defs>
              <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#06B6D4" />
                <stop offset="100%" stopColor="#3B82F6" />
              </linearGradient>
              <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#FACC15" />
                <stop offset="100%" stopColor="#FCD34D" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
      
      {/* Logo Text - Minimalist Typography */}
      {showText && (
        <div className="flex flex-col -space-y-1">
          <span className={`${sizeClasses.text} ${sizeClasses.letterSpacing} font-black bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent`}>
            EDGE
          </span>
          <span className={`${sizeClasses.text} ${sizeClasses.letterSpacing} font-black bg-gradient-to-r from-yellow-400 to-amber-500 bg-clip-text text-transparent`}>
            TRADE
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
